var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3403 10.8566V3.64358C19.3403 2.36157 18.3011 1.32227 17.019 1.32227H6.06938C4.78734 1.32227 3.74805 2.36157 3.74805 3.64358V30.6763M1.18555 30.6772H12.5427M3.74805 7.28432H9.37118M3.74805 13.1415H12.5427M17.0943 30.6763C17.1065 29.5065 17.4129 28.3588 17.9851 27.3405C19.191 25.1947 21.5069 23.8322 23.9555 23.8267C26.4039 23.8322 28.7198 25.1947 29.9258 27.3405C30.4979 28.3588 30.8044 29.5065 30.8165 30.6763M23.9555 22.93C26.1651 22.93 27.9562 21.1387 27.9562 18.9291C27.9562 16.7195 26.1651 14.9283 23.9555 14.9283C21.7458 14.9283 19.9546 16.7195 19.9546 18.9291C19.9546 21.1387 21.7458 22.93 23.9555 22.93Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.3e2ee73d3a4e1882c8e4aa32f7e5bbbe.svg";
export { ForwardRef as ReactComponent };